import { createSlice } from "@reduxjs/toolkit";
import { doBlockUser, doFetchUserList } from "./user.action";
import { User } from "../config";

interface Meta {
  totalItems: number;
  totalFreeUsers: number;
  totalPaidUsers: number;
  totalAllUsers: number;
  itemsPerPage: number;
  totalPages: number;
  currentPage: number;
}

interface userState {
  users: User[];
  meta: Meta | null;
  loading: boolean;
  error: string | null;
}
const initialState: userState = {
  users: [] as User[],
  meta: null,
  loading: false,
  error: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch user list
    builder
      .addCase(doFetchUserList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doFetchUserList.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(doFetchUserList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // block/unblock user
    builder
      .addCase(doBlockUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doBlockUser.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
      })
      .addCase(doBlockUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default userSlice.reducer;
